import FunctionalWorkerService from '../../services/FunctionalWorkerService';
import APIFunctionalWorker from './API.functional.worker';
import {
  API_REQUEST_MESSAGE,
  XSRF_COOKIE_NAME,
  XSRF_HEADER_NAME,
} from './constants';
import { getCookieValue } from '../../util/document';

export default class APIWorkerService extends FunctionalWorkerService {
  _options = null;

  constructor(options) {
    super(APIFunctionalWorker);
    this._options = options;
  }

  delete = (url, config) => {
    return this._makeRequest('delete', url, this._buildConfig(config));
  };

  get = (url, config) => {
    return this._makeRequest('get', url, this._buildConfig(config));
  };

  post = (url, data, config) => {
    return this._makeRequest('post', url, this._buildConfig(config), data);
  };

  put = (url, data, config) => {
    return this._makeRequest('put', url, this._buildConfig(config), data);
  };

  _buildConfig = (requestConfig) => {
    // Note: intentionally using just 'location' because workers don't have access to 'window'.
    let pathName = self.location.pathname;

    // Special case for /welcome where we do not want to return to it from the auth session.
    if (pathName === '/welcome') {
      pathName = '/';
    }

    // Add srcPath so auth headers know where we want to go if we aren't authed
    const apiParams = {
      srcPath: `${pathName}${self.location.search}${self.location.hash}`,
    };

    // Merge request and default config
    const mergedConfig = Object.assign({}, requestConfig);

    // Set up api specific params.
    mergedConfig.params = Object.assign({}, mergedConfig.params, apiParams);

    // Set up XSRF header (workers cannot read cookies)
    mergedConfig.headers = Object.assign({}, mergedConfig.headers, {
      [XSRF_HEADER_NAME]: getCookieValue(XSRF_COOKIE_NAME),
    });

    return mergedConfig;
  };

  _makeRequest = (method, url, config, requestData) => {
    let data = requestData;
    let formData = null;
    if (data instanceof FormData) {
      formData = {};
      for (const [key, value] of data.entries()) {
        formData[key] = value;
      }
      data = null;
    }

    const requestConfig = {
      ...config,
      data,
      method,
      url,
    };

    // Post message to APIFunctionalWorker
    return this.postMessage(API_REQUEST_MESSAGE, {
      formData,
      options: this._options,
      requestConfig,
    });
  };
}
